/**
 * Smooth Scroll Utility
 * Handles smooth scrolling navigation between page sections
 */

/**
 * Smoothly scrolls to a section by its ID
 * - Uses native smooth scroll behavior
 * - Handles missing section IDs gracefully
 * - Scrolls to top as fallback if section not found
 * 
 * @param sectionId - The ID of the target section element
 * 
 * @example
 * scrollToSection('about') // Scrolls to element with id="about"
 * scrollToSection('missing') // Logs warning and scrolls to top
 */
export function scrollToSection(sectionId: string): void {
  const element = document.getElementById(sectionId);

  if (!element) {
    console.warn(`Section not found: ${sectionId}`);
    // Fallback: scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}
